import styles from './styles.module.scss';
import Icons from '../../icons';
import moment from 'moment';
import { Popover } from 'antd';
import { useState } from 'react';

type PromoActionsPropsType = {
  promo: any;
  editHandler: Function;
  statusChangeHandler: Function;
};

const PromoActions = (props: PromoActionsPropsType) => {
  const { promo, editHandler, statusChangeHandler } = props;
  const [showPopover, setShowPopover] = useState<boolean>(false);

  const isPromoActive = (): boolean => {
    if (!promo.IsActive) return false;

    if (!promo.ExpirationDate) return true;

    const inputDate = moment(promo.ExpirationDate).startOf('day');
    const today = moment().startOf('day');

    if (inputDate.isBefore(today)) return false;

    return true;
  };

  const isPromoValid = (): boolean => {
    if (!promo.ExpirationDate) return true;

    const inputDate = moment(promo.ExpirationDate).startOf('day');
    const today = moment().startOf('day');

    if (inputDate.isBefore(today)) return false;

    return true;
  };

  const getContent = () => {
    return (
      <div className={styles.menu}>
        <div
          className={styles.item}
          onClick={() => {
            setShowPopover(false);
            editHandler(promo);
          }}
        >
          <span className={styles.icon}>
            <Icons variant={Icons.EDIT} />
          </span>
          <div className={styles.label}>Edit</div>
        </div>
        {isPromoValid() ? (
          <div
            className={styles.item}
            onClick={() => {
              setShowPopover(false);
              statusChangeHandler(!isPromoActive(), promo.Id);
            }}
          >
            <span className={styles.icon}>
              <Icons variant={isPromoActive() ? Icons.ARCHIVE : Icons.PROMO} color="#FF576D" />
            </span>
            <div className={styles.label}>{isPromoActive() ? 'Deactivate' : 'Activate'}</div>
          </div>
        ) : null}
      </div>
    );
  };

  const handleOpenChange = (newOpen: boolean) => {
    setShowPopover(newOpen);
  };

  return (
    <Popover
      content={getContent()}
      title=""
      trigger="click"
      placement="bottomRight"
      open={showPopover}
      onOpenChange={handleOpenChange}
    >
      <div className={styles.promoActions}>
        <Icons variant={Icons.HAMBURGER} className={styles.hbIcon} />
      </div>
    </Popover>
  );
};

export default PromoActions;
